import { useState, useCallback } from 'react';
import { apiClient } from '../httpClient';

const useApi = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);

    const request = useCallback(async (config) => {
        setLoading(true);
        setError(null);

        try {
            const response = await apiClient.request(config);
            setData(response.data);
            return { success: true, data: response.data };
        } catch (err) {
            const errorData = {
                message: err.response?.data?.message || err.message,
                status: err.response?.status,
                detail: err.response?.data?.detail
            };

            setError(errorData);
            return { success: false, error: errorData };
        } finally {
            setLoading(false);
        }
    }, []);

    const get = useCallback((url, params) => {
        return request({ method: 'GET', url, params });
    }, [request]);

    const post = useCallback((url, data) => {
        return request({ method: 'POST', url, data });
    }, [request]);

    const put = useCallback((url, data) => {
        return request({ method: 'PUT', url, data });
    }, [request]);

    const del = useCallback((url) => {
        return request({ method: 'DELETE', url });
    }, [request]);

    const reset = useCallback(() => {
        setData(null);
        setError(null);
        setLoading(false);
    }, []);

    return {
        loading,
        error,
        data,
        get,
        post,
        put,
        delete: del,
        reset
    };
};

export default useApi; 